import Grid from "@mui/material/Grid";
import DialogMui from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Icons } from "../../../utils/viewUtility";
import lang from "../../../core/constants/lang";
import ArrowLeft from "@mui/icons-material/ArrowLeft";
import Icon from "../Icon/Icon";
import styles from "./DialogCss";
import useStyles from "@hooks/useStyle";

const Dialog = (props: any) => {
	const { classes, cx } = useStyles(styles) as any;

	return (
		<DialogMui
			hideBackdrop={props.hideBackdrop}
			onBackdropClick={props.onBackdropClick}
			open={typeof props.open !== "undefined" ? props.open : true}
			PaperProps={props.PaperProps ?? {}}
			className={props.className ? cx(props.className, classes.root) : classes.root}
			onClose={props.onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullScreen={!!props.fullScreen}
		>
			{props.allowBack || props.title || props.closeable ? (
				<Grid container className={classes.navGrid} direction="row" justifyContent="center" alignItems="center">
					<Grid
						item
						className={classes.back}
						style={{
							visibility: props.allowBack ? "visible" : "hidden",
						}}
						xs={1}
					>
						<ArrowLeft className={classes.arrowLeft} onClick={props.onBackPressed} />
					</Grid>

					<Grid
						item
						style={{
							visibility: props.title ? "visible" : "hidden",
						}}
						xs={8}
					>
						{props.title ? (
							<DialogTitle id="alert-dialog-title-1" className={classes.title}>
								{props.title}
							</DialogTitle>
						) : (
							""
						)}
					</Grid>

					<Grid
						item
						className={classes.close}
						style={{
							visibility: props.closeable ? "visible" : "hidden",
						}}
						xs={2}
					>
						<Icon iconType={Icons.CLOSE_IMAGE} className={classes.closeImg} onClick={props.onClose} />
					</Grid>
				</Grid>
			) : null}
			<DialogContent className={props.contentClassName ?? ""} style={props.contentStyle}>
				{props.children}
			</DialogContent>
			{props.actionBtn ? (
				<DialogActions id={"qwerty"}>
					<Button
						variant={"contained"}
						size="large"
						className={classes.actionBtn}
						color={"primary"}
						onClick={props.handleClose}
					>
						{lang.OK}
					</Button>
				</DialogActions>
			) : null}
		</DialogMui>
	);
};
export default Dialog;
